import { Component, EventEmitter, Input, OnInit, OnDestroy, OnChanges, Output } from '@angular/core';

import { StudentAgreementsStatus, StudentCollegeInfo } from '../../../services/application/application.service';
import { UserInfo } from '../../../services/user/user.service';

@Component({
    selector: 'agreements-panel',
    styleUrls: ['agreements.component.css'],
    templateUrl: 'agreements.component.html',
})
export class AgreementsPanelComponent implements OnInit, OnDestroy, OnChanges {
    // Inputs
    @Input() AgreementChecks: StudentAgreementsStatus;
    @Input() AsParent: boolean;
    @Input() PCSBAgreementDate: Date;
    @Input() PCSBAgreementText: string;
    @Input() PCSBAgreementConsentText: string;
    @Input() SelectedCollege: StudentCollegeInfo;
    @Input() SelectedSchoolYear: string;
    @Input() StudentPolkAgreementApproved: boolean;
    @Input() User: UserInfo;

    // Outputs
    @Output() submit: EventEmitter<boolean> = new EventEmitter<boolean>();

    // Class
    ViewReady: boolean;

    constructor() {}

    ngOnDestroy() {}

    ngOnInit() {}

    ngOnChanges() {
        this.ViewReady = true;
    }

    // #region Submit Approval Method

    SubmitApproval() {
        this.submit.emit(true);
    }

    // #endregion
}



// WEBPACK FOOTER //
// ./src/app/ui/agreements/agreements.component.ts